/**
 * Phase 10D: Lebanon-specific / regional configuration.
 */

export const REGIONAL_CONFIG = {
  dataCenter: 'Beirut-DC1',
  backupLocation: 'Tripoli-DC2',

  apiBaseURL: process.env.REACT_APP_API_URL || '',
  cdnURL: process.env.REACT_APP_CDN_URL || '',

  defaultLocale: 'ar',
  supportedLocales: ['ar', 'en'],
  defaultCurrency: 'USD',
  supportedCurrencies: ['USD', 'LBP'],

  minRenewalCheckDays: 180,
  maxSavingsDisplayAmount: 10000,
  defaultCheckSchedule: [90, 60, 30, 7],

  apiTimeout: Number(process.env.REACT_APP_API_TIMEOUT) || 30000,
  retryAttempts: 3,
  cacheExpiry: 3600000,
};

export const MAX_POLICIES_PER_COMPARISON = Number(process.env.REACT_APP_MAX_POLICIES_PER_COMPARISON) || 5;
export const CALENDAR_MONTHS_VISIBLE = Number(process.env.REACT_APP_CALENDAR_MONTHS_VISIBLE) || 3;
